import app from "./config/configApp";
import router from "./routes/protectedRoute";
import store from "@/vuex/store";
import socketPlugin from "./services/socket.js"; // Import the plugin
import BreadcrumbComponent from "./components/BreadcrumbComponent.vue";

import "./static/css/style.css";
// Vue 3rd party plugins
import "@/core/plugins/ant-design";
import "@/core/plugins/fonts";
import "@/core/plugins/maps";
import "@/core/plugins/masonry";
import "@/core/plugins/apexcharts";
import "@/core/plugins/unicons";
import "@/core/components/custom";

import request from "./services/request";
import { i18n } from "./i18n/config";
app.config.productionTip = false;
app.use(store);
app.use(router);
app.use(socketPlugin);
app.use(request);
app.use(i18n);
app.component("BreadcrumbComponent", BreadcrumbComponent);
app.mount("#app");
